import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';
import SEO from '../components/SEO';

const HowToList = () => {
  const steps = [
    { step: '01', title: 'Create an organizer account', d: 'Sign up in under a minute. No credit card.' },
    { step: '02', title: 'Create your tournament', d: 'Fill in format, dates, venue, prizes, and registration fee. Upload a banner and (if paid) your UPI QR code.' },
    { step: '03', title: 'Get approved', d: 'Our team reviews every tournament within 24 hours to keep the platform high-quality.' },
    { step: '04', title: 'Go live', d: 'Your tournament is now discoverable to players across India. They register directly on Beyond Ball India.' },
    { step: '05', title: 'Review registrations', d: 'Verify payment screenshots (for paid tournaments) and approve or reject each registration.' },
    { step: '06', title: 'Manage from one dashboard', d: 'See rosters, analytics, and payments in one place. Edit anytime.' }
  ];

  return (
    <>
      <SEO title="List Your Tournament" description="Host your basketball tournament on Beyond Ball India. Reach players across the country. Free to list. Admin-verified for quality." path="/how-to-list" />
      <div className="pt-24 pb-16 min-h-screen">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold text-[#F97316] uppercase tracking-wider mb-2">For organizers</div>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 mb-4 animate-fade-up" data-testid="how-to-list-title">
            List your tournament in 6 steps
          </h1>
          <p className="text-gray-600 text-lg mb-12 animate-fade-up delay-100">Reach every basketball player in India. Free to list, easy to manage.</p>

          <div className="space-y-4">
            {steps.map((s) => (
              <div key={s.step} className="bg-white border border-gray-200 rounded-2xl p-6 flex gap-6 animate-fade-up" style={{animationDelay: `${(s.step - 1) * 60}ms`}} data-testid={`step-${s.step - 1}`}>
                <div className="text-3xl font-bold text-[#F97316] flex-shrink-0">{s.step}</div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-1">{s.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{s.d}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 bg-orange-50 border border-orange-100 rounded-2xl p-6 animate-fade-up">
            <h3 className="font-bold text-gray-900 mb-2">Everything happens on Beyond Ball India</h3>
            <p className="text-gray-700 text-sm leading-relaxed">No Google Forms, no redirects. Players register directly on your tournament page, upload their payment proof if required, and you approve them from your dashboard.</p>
          </div>

          <div className="mt-10 text-center">
            <Link to="/register" className="btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-base font-semibold">
              Create organizer account <ArrowRight size={18} weight="bold" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowToList;
